import React from 'react';
import { Button } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import MercurXIcons from '../../components/MercurXIcons/MercurXIcons';
import { isAuthenticated } from '../../helpers/userHelper';
import './NotFound.scss';

function NotFound() {
  const history = useHistory();
  const location = useLocation();
  const authenticated = isAuthenticated();

  function goHome() {
    history.push(authenticated ? '/' : '/login');
  }

  function goBack() {
    history.goBack();
  }

  return (
    <div className="not-found-page">
      <div className="not-found-card">
        <div className="not-found-code">404</div>
        <div className="text-fs-head-md text-dark mb-2">Page Not Found</div>
        <div className="text-fs-body-md text-t-body-color mb-3">
          The page you are looking for does not exist or may have been moved.
        </div>
        <div className="not-found-path text-fs-body-sm mb-4">
          Requested path: <span>{location.pathname}</span>
        </div>
        <div className="not-found-actions">
          <Button size="sm" onClick={goHome}>
            <span className="d-inline-flex align-items-center">
              <MercurXIcons name="BsHouse" size={16} className="me-1" />
              Go to Home
            </span>
          </Button>
          <Button size="sm" variant="light" className="text-t-body-color" onClick={goBack}>
            <span className="d-inline-flex align-items-center">
              <MercurXIcons name="BsArrowLeftShort" size={18} className="me-1" />
              Go Back
            </span>
          </Button>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
